var _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line2, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktopAiPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 868,
  height: 827,
  viewBox: "0 0 868 827",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 868,
  y1: 1.2832,
  x2: -4.37113e-8,
  y2: 1.28313,
  stroke: "black"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 16.7832,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 63.7832,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 89.7832,
  width: 568,
  height: 62,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  y: 159.783,
  width: 568,
  height: 40,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  y: 211.783,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  y: 245.783,
  width: 568,
  height: 379,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 568,
  y1: 645.283,
  x2: -4.37113e-8,
  y2: 645.283,
  stroke: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  y: 664.783,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  y: 690.783,
  width: 568,
  height: 62,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  y: 760.783,
  width: 568,
  height: 40,
  fill: "#E5E5E5"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  y: 812.783,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 63.7832,
  width: 100,
  height: 18,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 93.7832,
  width: 268,
  height: 62,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 167.783,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 201.783,
  width: 100,
  height: 18,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 231.783,
  width: 268,
  height: 62,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 305.783,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 339.783,
  width: 100,
  height: 18,
  fill: "#E5E5E5"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 369.783,
  width: 268,
  height: 62,
  fill: "#E5E5E5"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 443.783,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 477.783,
  width: 100,
  height: 18,
  fill: "#E5E5E5"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 507.783,
  width: 268,
  height: 62,
  fill: "#E5E5E5"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 600,
  y: 581.783,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})));
export default SvgDesktopAiPlaceholder;